import {gql} from "@apollo/client";

export const getMedicationsQuery = gql`
  query getMedications($clientId: ID!) {
    medications( clientId: $clientId) {id, name, dosage}
  }
`;

export const createMedicationMutation = gql`
  mutation createMedication($name: String!, $dosage: String!, $clientId: ID!){
    createMedication(
      input: {
        name: $name,
        dosage: $dosage,
        clientId: $clientId
      }) {
      medication {
        id
      }
    }
  }
`

export const deleteMedicationMutation = gql`
  mutation deleteMedication($id: ID!){
    deleteMedication(
      input: {id: $id}) {
      medication {
        id
      }
    }
  }
`